import axios, { AxiosPromise } from 'axios'

import {
  clearAuthStorage,
  getRefreshToken as getStoredRefreshToken,
  persistTokens,
  refreshAccessToken,
} from '@/lib/auth/authSession'
import { apiUrl, getAxiosRequestConfigWithHeaders } from '@/lib/misc/Utils'
import { UserAndCompany, OIDCAuthRequest } from '../definitions/api.types'

interface LoginRequest {
  email: string
  password: string
  two_factor_auth_code?: string
  use_recovery_code?: boolean
}

interface SignUpRequest {
  name: string
  email: string
  password1: string
  password2: string
}

export interface LoginResponse {
  access_token: string
  refresh_token: string
  two_factor_auth: boolean
  user: {
    pk: string
    username: string
    email: string
    first_name: string
    last_name: string
  }
}

export class AuthService {
  getRefreshToken(): string | null {
    return getStoredRefreshToken()
  }

  login(data: LoginRequest) {
    return axios.post(apiUrl('/api/v1/auth/login'), data, {
      _skipAuthRefresh: true,
    })
  }

  OIDCAuth(data: OIDCAuthRequest) {
    const configs = getAxiosRequestConfigWithHeaders()
    return axios.post(
      apiUrl('/api/v1/user/oidc-authenticate-jwt'),
      data,
      configs
    )
  }

  signup(data: SignUpRequest): AxiosPromise {
    return axios.post(apiUrl('/auth/registration/'), data)
  }

  logout(): AxiosPromise {
    localStorage.removeItem('customerId')
    return axios.post(apiUrl('/auth/logout/'))
  }

  clear() {
    clearAuthStorage()
  }

  refreshToken() {
    return refreshAccessToken().then((access) => ({ access }))
  }

  getUser(): AxiosPromise<UserAndCompany> | null {
    const configs = getAxiosRequestConfigWithHeaders()

    return Object.entries(configs).length
      ? axios.get(apiUrl('/api/v1/user/me'), configs)
      : null
  }

  static persistLoginTokens(userData: {
    access_token?: string
    access?: string
    refresh_token?: string
    refresh?: string
  }): void {
    const access = userData.access_token ?? userData.access
    const refresh = userData.refresh_token ?? userData.refresh
    if (!access) {
      return
    }
    persistTokens({ access, refresh })
  }
}
